import { LucideIcon } from 'lucide-react'

interface StatCardProps {
  title: string
  value: string | number
  icon: LucideIcon
  description?: string
}

export default function StatCard({ title, value, icon: Icon, description }: StatCardProps) {
  return (
    <div className="flex flex-col gap-1 px-6 py-5 bg-gray-50 rounded-md">
      <div className="flex items-center justify-between">
        <span className="text-sm text-gray-500 font-medium">{title}</span>
        <Icon className="h-6 w-6 text-gray-500 bg-indigo-50 p-1 rounded" />
      </div>
      <p className="text-3xl font-bold text-gray-900">{value}</p>
      {description && (
        <p className="text-xs text-gray-400">{description}</p>
      )}
    </div>
  )
}
